import React, { forwardRef } from 'react';
import {
  FieldProps,
  InjectedFieldProps,
  useDataProvider,
  useNotify,
  useRefresh,
} from 'react-admin';
import MenuItem from '@material-ui/core/MenuItem';

import { Confirmation } from 'components/common';
import { RewardBadgeDto } from '../../types';

type DeleteBadgeActionFieldProps = (FieldProps & InjectedFieldProps) & {
  record?: RewardBadgeDto;
};

const DeleteBadgeActionField = forwardRef<HTMLLIElement, DeleteBadgeActionFieldProps>(
  ({ record }, ref) => {
    const dataProvider = useDataProvider();
    const notify = useNotify();
    const refresh = useRefresh();

    const handleDeleteBadge = async () => {
      if (!record?.id) {
        return;
      }

      try {
        await dataProvider.delete('rewardsBadge', { id: record.id });
        refresh();
      } catch (error: unknown) {
        const message = error instanceof Error ? error.message : 'Failed to delete rewards badge';
        notify(message);
      }
    };

    return (
      <Confirmation title="Delete badge" content="Are you sure you want to delete this badge?">
        <MenuItem ref={ref} onClick={handleDeleteBadge}>
          Delete
        </MenuItem>
      </Confirmation>
    );
  }
);

export default DeleteBadgeActionField;
